import sample from 'lodash/sample'
import { BASE_CHAIN_ID_NUMBER, ETH_CHAIN_ID_NUMBER } from '@mprolab/sdk'

/** Same-origin JSON-RPC proxy — upstream URLs and keys live only on the server (Vite dev / api-gateway). */
const ETH_RPC = '/api/rpc/ethereum'
const BASE_RPC = '/api/rpc/base'

export const ethereumNodes = [ETH_RPC]
export const baseNodes = [BASE_RPC]

export const bscNodes: string[] = []
export const polygonNodes: string[] = []
export const arbitrumNodes: string[] = []

export const getBscNodeUrl = (): string => {
  return (sample(bscNodes) as string) || ETH_RPC
}
export const getPolygonNodeUrl = (): string => {
  return (sample(polygonNodes) as string) || ETH_RPC
}
export const getEthereumNodeUrl = (): string => {
  return ETH_RPC
}

export const getArbitrumNodeUrl = (): string => {
  return (sample(arbitrumNodes) as string) || ETH_RPC
}

export const getBaseNodeUrl = (): string => {
  return BASE_RPC
}

export const getRpcUrlByChainId = (chainId: number): string => {
  if (chainId === ETH_CHAIN_ID_NUMBER) {
    return getEthereumNodeUrl()
  }
  if (chainId === BASE_CHAIN_ID_NUMBER) {
    return getBaseNodeUrl()
  }

  switch (chainId) {
    default:
      return getEthereumNodeUrl()
  }
}
